<template>
  <div>Field Multiple product</div>
</template>

<script>
import option_field from "../../../mixin/option-field.js";
export default {
  name: "field_multiple_product",
  mixins: [option_field]
};
</script>
